const skillsData = [
	{
		title: 'Frontend-&-Frameworks',
		skills: [
			{ name: 'react', value: 'true', hasComma: true },
			{
				name: 'next.js',
				value: null,
				hasComma: true,
				nested: [
					{ name: 'app-router', value: 'true', hasComma: true },
					{ name: 'ssr', value: 'true', hasComma: true },
					{ name: 'ssg', value: 'true', hasComma: false },
				],
			},
			{ name: 'typescript', value: 'true', hasComma: true },
			{ name: 'javascript-es6+', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'State-Management-&-Data-Fetching',
		skills: [
			{ name: 'tanstack-query', value: 'true', hasComma: true },
			{ name: 'react-query', value: 'true', hasComma: true },
			{ name: 'zustand', value: 'true', hasComma: true },
			{ name: 'redux-toolkit', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'Forms-&-Validation',
		skills: [
			{ name: 'react-hook-form', value: 'true', hasComma: true },
			{ name: 'zod', value: 'true', hasComma: true },
			{ name: 'yup', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'UI-Styling-&-Design-System',
		skills: [
			{ name: 'chakra-ui', value: 'true', hasComma: true },
			{ name: 'tailwindcss', value: 'true', hasComma: true },
			{ name: 'material-ui', value: 'true', hasComma: true },
			{ name: 'shadcn/ui', value: 'true', hasComma: true },
			{ name: 'sass/scss', value: 'true', hasComma: true },
			{ name: 'vuexy', value: 'true', hasComma: true },
			{ name: 'razor', value: 'true', hasComma: true },
			{ name: 'liquid', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'API-Authentication-&-Integrations',
		skills: [
			{ name: 'rest-api', value: 'true', hasComma: true },
			{
				name: 'axios',
				value: null,
				hasComma: true,
				nested: [
					{ name: 'interceptors', value: 'true', hasComma: true },
					{ name: 'error-handling', value: 'true', hasComma: true },
					{ name: 'polling', value: 'true', hasComma: false },
				],
			},
			{
				name: 'oauth',
				value: null,
				hasComma: true,
				nested: [
					{ name: 'google', value: 'true', hasComma: true },
					{ name: 'linkedin', value: 'true', hasComma: false },
				],
			},
			{ name: 'jwt', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'E-commerce-&-Application-Flows',
		skills: [
			{ name: 'checkout-flow', value: 'true', hasComma: true },
			{ name: 'cart-management', value: 'true', hasComma: true },
			{ name: 'silent-login', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'Internationalization',
		skills: [
			{ name: 'multilingual-routing', value: 'true', hasComma: true },
			{ name: 'i18next', value: 'true', hasComma: true },
			{ name: 'next-intl', value: 'true', hasComma: false },
		],
		hasComma: true,
	},
	{
		title: 'Tools-&-Methodologies',
		skills: [
			{ name: 'azure-devops', value: 'true', hasComma: true },
			{ name: 'git', value: 'true', hasComma: true },
			{ name: 'agile', value: 'true', hasComma: true },
			{ name: 'scrum', value: 'true', hasComma: true },
			{ name: 'gtm', value: 'true', hasComma: true },
			{ name: 'klaviyo', value: 'true', hasComma: true },
			{ name: 'tracking', value: 'true', hasComma: false },
		],
		hasComma: false,
	},
];

const SkillItem = ({ skill }) => {
	if (skill.nested) {
		return (
			<li>
				<span className="skills-key second-title"> "{skill.name}"</span>:{' '}
				<span className="inner-curly">&#123;</span>
				<ul className="inner">
					{skill.nested.map((nestedSkill, idx) => (
						<li key={idx}>
							<span className="skills-key"> "{nestedSkill.name}"</span>:{' '}
							<span className="skills-value">
								{nestedSkill.value}
								{nestedSkill.hasComma && ','}
							</span>
						</li>
					))}
				</ul>
				<span className="inner-curly inner">&#125;{skill.hasComma && ','}</span>
			</li>
		);
	}

	return (
		<li>
			<span className="skills-key second-title"> "{skill.name}"</span>:{' '}
			<span className="skills-value">
				{skill.value}
				{skill.hasComma && ','}
			</span>
		</li>
	);
};

const SkillSection = ({ section }) => (
	<div className="skills-wrapper">
		<span className="skills-title">
			<h2>"{section.title}"</h2>: <span className="curly">&#123;</span>
		</span>
		<ul>
			{section.skills.map((skill, idx) => (
				<SkillItem key={idx} skill={skill} />
			))}
		</ul>
		<span className="curly">&#125;{section.hasComma && ','}</span>
	</div>
);

function Skills() {
	return (
		<div id="content-tabs">
			<div>
				<h1>
					&#x2039;
					<span className="title">Skills</span> &#47;&#x203A;
				</h1>
				{skillsData.map((section, idx) => (
					<SkillSection key={idx} section={section} />
				))}
			</div>
		</div>
	);
}

export default Skills;
